import type React from "react";
import { createContext, useMemo, useState } from "react";

export type LoadingContext = {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultValue: LoadingContext = {
  isLoading: false,
  setIsLoading: () => {},
};

/**
 * ローディング状態を管理する
 */
export const LoadingContext = createContext(defaultValue);

export const LoadingMutationProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  const value = useMemo(() => ({ isLoading, setIsLoading }), [isLoading]);

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
